import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TemplatesService } from '../templates/templates.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-view-review-modal',
  templateUrl: './view-review-modal.component.html',
  styleUrls: ['./view-review-modal.component.css']
})
export class ViewReviewModalComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private toastr: ToastrService, public dialog: MatDialog, public dialogRef: MatDialogRef<ViewReviewModalComponent>) {

  }
  ratinglist: any;
  ngOnInit() {
    this.ratinglist = this.data.ratings
  }
  close() {
    this.dialogRef.close()
  }
  closeDialog() {
    this.dialogRef.close(this.data)
  }

}
